import ReactMarkdown from "react-markdown";
import LReviewCard from "../lreview-card/LReviewCard";
import WSlider from "../wslider/WSlider";
import parse from "html-react-parser";

/* eslint-disable-next-line */
export interface LReviewsSectionProps {
  id?: string;
  topTitle?: string;
  mainTitle?: string;
  size?: "small" | "medium" | "big";
  hideImage?: boolean;
  description?: string; // rich text
  box?: boolean;
  boxColor?: string;
  textColor?: string;
  itemBoxColor?: string;
  itemBoxTextColor?: string;
  reviewItem?: {
    numberOfChars?: number;
    title?: string;
    content?: string; //rich text
    authorPicture?: {
      url: string;
      altTag: string;
      formats?: any;
    };
    authorName?: string;
    authorLocation?: string;
    authorOccupations?: string;
    showPictureAsCircle?: boolean;
  }[];
}

export function LReviewsSection(props: LReviewsSectionProps) {
  return (
    <div className="bg-eklight p-4" id={props?.id}>
      <div
        className="container flex flex-col gap-3 px-6 lg:px-24 py-6 mx-auto lg:max-w-8xl rounded-xl"
        style={{
          color: props?.textColor || "#358A4F",
          backgroundColor: props.box
            ? props.boxColor
            : "rgba(255, 255, 255, 0.1)",
        }}
      >
        <div className="text-xl font-semibold">{props?.topTitle}</div>
        <h1 style={{ color: props?.textColor }}>
          {parse(props?.mainTitle ?? "")}
        </h1>
        {props?.description && (
          <div style={{ color: props?.textColor }}>
            <ReactMarkdown>{props?.description}</ReactMarkdown>
          </div>
        )}

        <WSlider>
          {props?.reviewItem?.map((review, key) => (
            <LReviewCard
              key={key}
              textColor={props?.textColor}
              itemBoxColor={props?.itemBoxColor}
              itemBoxTextColor={props?.itemBoxTextColor}
              authorPicture={{
                url: review?.authorPicture?.url ?? "",
                altTag: review?.authorPicture?.altTag ?? "",
                formats: review?.authorPicture?.formats,
              }}
              title={review?.title}
              content={review?.content}
              authorLocation={review?.authorLocation}
              authorName={review?.authorName}
              authorOccupations={review?.authorOccupations}
              showPictureAsCircle={review?.showPictureAsCircle}
              numberOfChars={review?.numberOfChars}
              size={props?.size}
              hideImage={props?.hideImage}
            />
          ))}
        </WSlider>
      </div>
    </div>
  );
}

export default LReviewsSection;
